module.exports = __webpack_public_path__ + "static/media/france_ouest.66637cdb.svg";